import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { APIURL } from "../../../config";
import moment from "moment";
import { TextField, Button, Box, Link, Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Snackbar, Alert, IconButton, Autocomplete, CircularProgress, Chip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import "./ChangeCapture.css";
import Upload from "./Upload";
import MonthlyTool from "../../../container/SupportCoordinator/MonthlyMonitoring/MonthlyTool/MonthlyTool";
import QuarterlyAnnualTool from "../../../container/SupportCoordinator/MonthlyMonitoring/QuarterlyAnnualTool/QuarterlyAnnualTool";
import { DataGridPro, useGridApiRef, ToolbarButton } from '@mui/x-data-grid-pro';
import DefaultToolbar from "src/components/DataGrid/DefaultToolbar";
import SaveViewButton from "src/components/DataGrid/SaveViewButton";
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../../config';
import { Form } from '@formio/react';
import FormAttachments from 'src/components/forms/FormAttachments/FormAttachments';
import { convertTime } from "src/utils/time";

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

export default function ChangeCapture(props) {
  const [gridId, setGridId] = useState(62);
  const apiRef = useGridApiRef();
  const ref = useRef();

  const [primaryBusinessType, setPrimaryBusinessType] = useState(null)
  const [claimsList, setClaimsList] = useState([]);
  const [formattedRows, setFormattedRows] = useState([]);
  const [currentMonth, setCurrMonth] = useState(moment().startOf("month"));
  const [currentMonthEnd, setCurrMonthEnd] = useState(moment().endOf("month"));
  const [isLoading, setLoading] = useState(true);
  const [nextStepStatus, setNextStep] = useState(false);
  const [csvAdd, setCsvAdd] = useState(false);
  const [updateData, setUpdateData] = useState(false);
  const [selectionModel, setSelectionModel] = useState({
    type: 'include',
    ids: new Set(),
  });
  const [selectValidClaims, setSelectValidClaims] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mt, setMT] = useState({
    type: '',
    data: null,
  });
  const [showMT, setShowMT] = useState(false);
  const handleCloseMT = () => setShowMT(false);
  const [density, setDensity] = useState("standard");
  const [initialSettings, setInitialSettings] = useState({});
  const [orderedColumns, setOrderedColumns] = useState(props.columns ? props.columns.reduce((acc, col) => ([...acc, col.field]), []) : []);
  const [colVisModel, setColVisModel] = useState({
    // Hide columns status and traderName, the other columns will remain visible
    primaryID: false,
  });
  const [customerList, setCustomerList] = useState([]);
  const [newPAFormOpen, setNewPAFormOpen] = useState(false);
  const [addingPreAuth, setAddingPreAuth] = useState(false);
  const [PAFormData, setPAFormData] = useState({
    DDDID: '',
    memberMedicaid: '',
    providerMedicaid: '',
    priorAuth: '',
    procedureCode: '',
    startDate: moment(),
    endDate: moment(),
    authUnits: '',
    authAmount: '',
  });
  const [selectedTaskID, setSelectedTaskID] = useState(null);
  const [taskForms, setTaskForms] = useState([]);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [editNote, setEditNote] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [noteText, setNoteText] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [claimStatus, setClaimStatus] = useState(null);
  const [claimStatusLoading, setClaimStatusLoading] = useState(false);

  const logToSegment = () => {
    let page = String(window.location.href).split("/").pop()
    console.log(page, window.location.href)
    if (page.includes("fieldworker") || page === "") {
      page = "Home";
    } else {
      page = String(page).charAt(0).toUpperCase() + String(page).toLowerCase().slice(1);
    }
    console.log(page)
    analytics.page(page + " : Charge Capture : Changes Captured", {
      title: page + " : Charge Capture : Changes Captured",
      path: page + " : Charge Capture : Changes Captured",
    }, {
      userId: String(props.user.emp_id),
    })
    console.log("logged to segment successfully")
  }

  useEffect(() => {
    logToSegment()
  }, [])

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      const response = await axios.get(`${APIURL}/preauth`, {
        params: {
          companyID: props.comp_id,
          primaryBusinessType: primaryBusinessType,
          startDate: currentMonth.format('YYYY-MM-DD'),
          endDate: currentMonthEnd.format('YYYY-MM-DD'),
          // startIndex: start,
          // endIndex: end,
          // sortModel: JSON.stringify(sortModel || []),
          // filterModel: JSON.stringify(filterModel || { items: [] }),
        }
      });

      setClaimsList(response.data.rows.filter(row => row.ChargeIdentified !== '-'));

      const transformedRows = response.data.rows.map((item, index) => {
        if (primaryBusinessType === 101) {
          // Support Coordination format
          return {
            hierarchy: [item.ChargeIdentified, item.cus_name + ': ' + moment(item.startDate).utc().format('MM/DD') + ' - ' + moment(item.endDate).utc().format('MM/DD') + ' (' + index + ')'],
            id: index,
            primaryID: item.primaryID || null,
            DDDID: Array.isArray(item.DDDID) ? item.DDDID[0] : item.DDDID,
            PatientName: item.cus_name,
            DateOfBirth: item.dob ? moment(item.dob).utc().format("L") : '',
            Gender: item.gender || '',
            DDD_tier: item.DDD_tier || '',
            memberMedicaid: item.memberMedicaid,
            priorAuth: item.priorAuth,
            procedureCode: item.procedureCode,
            procedureCodeModifier: item.procedureCodeModifier || '',
            startDate: moment(item.startDate).isValid() ? moment(item.startDate).utc().format("L") : '',
            endDate: moment(item.endDate).isValid() ? moment(item.endDate).utc().format("L") : '',
            DiagnosisCode: item.PrimaryDiagnosisCode,
            authUnits: item.authUnits,
            authAmount: item.authAmount ? item.authAmount.toFixed(2) : '',
            Status: item.tas_preAuth_id ? 'Sent to Claims' : '',
            tas_title: item.tas_title,
            tas_type: item.tas_type,
            tas_start_date: item.tas_start_date ? moment(item.tas_start_date).utc().format("L") : '',
            taskStatus: item.tas_title ? 'Task Matched' : '',
            mmt: item.tas_id,
            errCode: item.errCode === 'None' ? '' : item.errCode,
            errDescription: item.errDescription === 'Null' ? '' : item.errDescription,
            tas_id: item.tas_id,
            task_id: item.tas_id,
            mt_status: item.tas_mm_status,
            billingNoteId: item.billing_note_id,
            billingNote: item.billing_note,
            ChargeIdentified: item.ChargeIdentified
          };
        } else {
          // Service Provider format
          const taskList = item.tasks;

          return {
            hierarchy: [item.ChargeIdentified, item.cus_name + ': ' + moment(item.startDate).utc().format('MM/DD') + ' - ' + moment(item.endDate).utc().format('MM/DD') + ' (' + index + ')'],
            id: index,
            primaryID: item.primaryID || null,
            DDDID: Array.isArray(item.DDDID) ? item.DDDID[0] : item.DDDID,
            PatientName: item.cus_name,
            DateOfBirth: item.dob ? moment(item.dob).utc().format("L") : '',
            Gender: item.gender || '',
            DDD_tier: item.DDD_tier || '',
            memberMedicaid: item.memberMedicaid,
            priorAuth: item.priorAuth,
            procedureCode: item.procedureCode,
            procedureCodeModifier: item.procedureCodeModifier || '',
            startDate: item.startDate ? moment(item.startDate).utc().format("L") : '',
            endDate: item.endDate ? moment(item.endDate).utc().format("L") : '',
            DiagnosisCode: item.PrimaryDiagnosisCode,
            authUnits: item.authUnits,
            authAmount: item.authAmount ? item.authAmount.toFixed(2) : '',
            Status: !!taskList.length ? (!!taskList[0].tas_preAuth_id ? 'Sent to Claims' : '') : !!item.tas_preAuth_id ? 'Sent to Claims' : '',
            taskStatus: item.taskIds ? 'Tasks Matched' : '',
            tas_ids: item.taskIds,
            tas_type: !!taskList.length ? taskList[0].tas_type : item.tas_type,
            cumulativeUnits: Math.round(item.cumulativeUnits || 0),
            remainingUnits: Math.round(item.cumulativeRemainingUnits || 0),
            errCode: item.errCode === 'None' ? '' : item.errCode,
            errDescription: item.errDescription === 'Null' ? '' : item.errDescription,
            isNewPlan: item.isNewPlan === 'Null' ? '' : item.isNewPlan,
            serviceType: item.serviceType === 'Null' ? '' : item.serviceType,
            billingNoteId: item.billing_note_id,
            billingNote: item.billing_note,
            ChargeIdentified: item.ChargeIdentified
          };
        }
      });

      setFormattedRows(transformedRows.filter(row => row.ChargeIdentified !== '-'));
      setLoading(false);
    }

    if (primaryBusinessType !== null) {
      fetchData();
    }
  }, [primaryBusinessType, csvAdd, addingPreAuth, currentMonth, editRow, updateData]);

  useEffect(() => {
    async function fetchData() {
      let getGridSettings = await axios.get(`${APIURL}/datagrid`, { params: { user_id: props.user.emp_id, report_id: gridId } });
      if (getGridSettings.data.length > 0) {
        let settings = JSON.parse(getGridSettings.data[0].settings);

        setInitialSettings({ ...settings });
        setColVisModel({ ...colVisModel, ...settings.columnVisibilityModel });
        // setSelectionModel(settings.selectionModel ? settings.selectionModel : { type: 'include', ids: new Set() });
        setDensity(settings.density ? settings.density : "standard");
        setOrderedColumns(settings.columns ? settings.columns.orderedFields : []);
      } else {
        let settings = props.initialState ? props.initialState : {};
        setInitialSettings({ ...settings });

        settings = settings ? JSON.stringify(settings) : JSON.stringify({});
        let saveGridSettings = await axios.post(`${APIURL}/datagrid`, { user_id: props.user.emp_id, report_id: gridId, settings: settings });
      }

      let pBusinessType = props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : 101

      // axios.defaults.headers = {
      //   "Content-Type": "application/json",
      //   "Access-Control-Allow-Origin": "*",
      //   "Access-Control-Allow-Headers":
      //     "Origin, X-Requested-With, Content-Type, Accept, Authorization",
      //   "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
      //   "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
      //   Authorization:
      //     "Bearer " + window.localStorage.getItem("Fw4_access_Token"),
      // };
      // let preAuth = await axios.get(APIURL + "/preauth", {
      //   params: { companyID: props.comp_id, primaryBusinessType: pBusinessType, fromDate: moment(currentMonth).subtract(2, 'months').format('MM/DD/YYYY'), toDate: moment(currentMonth).endOf("month").format('MM/DD/YYYY') },
      // });
      // let preAuthData = preAuth.data;
      // let id_num = 0;
      // for (var i = 0; i < preAuthData.length; i++) {
      //   preAuthData[i].ChargeIdentified = '-';
      //   preAuthData[i].id = id_num;
      //   id_num += 1;
      // }

      // let currMonthData = preAuthData.filter((obj) => moment(obj.startDate).utc().format('MM/YYYY') === moment(currentMonth).utc().format('MM/YYYY'))

      // let lastMonthData = preAuthData.filter((obj) => moment(obj.startDate).utc().format('MM/YYYY') === moment(currentMonth).subtract(1, 'months').format('MM/YYYY'))

      // let custDiff = currMonthData.filter(obj1 => !lastMonthData.some(obj2 => obj1.cus_id === obj2.cus_id))
      //   .concat(lastMonthData.filter(obj2 => !currMonthData.some(obj1 => obj2.cus_id === obj1.cus_id)));

      // custDiff.forEach((obj) => {
      //   if (currMonthData.some(data => data.cus_id === obj.cus_id)) {
      //     preAuthData.map((entry) => {
      //       if (entry.primaryID === obj.primaryID) {
      //         entry.ChargeIdentified = 'Customer added';
      //       }
      //     })
      //   }
      // })

      // setClaimsList(preAuthData);
      setPrimaryBusinessType(pBusinessType);
    }

    fetchData();
  }, [updateData]);

  useEffect(() => {
    async function sendToClaims(data) {
      try {
        const claimsStatus = await axios.post(APIURL + "/claims", {
          entries: data,
          comp_id: props.user.comp_id,
          emp_id: props.user.emp_id,
          emp_name: props.user.emp_name,
          primaryBusinessType: primaryBusinessType
        });

        const claimsCreated = claimsStatus.data?.claimsCreated;

        if (claimsStatus.data?.success === false) {
          setAlertMessage(claimsStatus.data?.message || 'The selected entries could not be sent to Claims.');
          setAlertType('error');
        } else if (claimsCreated !== undefined && claimsCreated !== data.length) {
          setAlertMessage(`Only ${claimsCreated} of ${data.length} entries were sent to Claims.`);
          setAlertType('error');
        } else {
          setAlertMessage('Entries successfully sent to Claims.');
          setAlertType('success');
        }
      } catch (error) {
        setAlertMessage(error.response?.data?.message || error.message);
        setAlertType('error');
      }

      setUpdateData(!updateData);
      setSelectValidClaims(false);
      setNextStep(false);
      setSelectionModel({ type: 'include', ids: new Set() });
    }

    if (nextStepStatus) {
      if (selectionModel.ids.size !== 0) {
        const filteredRows = formattedRows.filter(r => selectionModel.ids.has(r.id));

        const selectedPrimaryIDs = new Set(filteredRows.map(r => r.primaryID).filter(Boolean));

        const claimsListFiltered = claimsList.filter(claim => selectedPrimaryIDs.has(claim.primaryID));

        sendToClaims(claimsListFiltered);
      }
    }
  }, [nextStepStatus]);

  useEffect(() => {
    if (selectValidClaims) {
      let readyToSubmitRows = formattedRows
        .filter((r) => (primaryBusinessType === 101 ? ((r.mt_status === "Approved" || r.ChargeIdentified === 'Customer added') && r.priorAuth) : (r.tas_ids && r.priorAuth)) && r.Status !== 'Sent to Claims' && moment(r.startDate).utc().month() === currentMonth.month() && moment(r.startDate).utc().year() === currentMonth.year() && r.PatientName)
        .map((r) => r.id);
      setSelectionModel({ type: 'include', ids: new Set(readyToSubmitRows) });
    }
    else {
      setSelectionModel({ type: 'include', ids: new Set() });
    }
  }, [selectValidClaims]);

  useEffect(() => {
    if (primaryBusinessType === 101) {
      getSC_ChangedList();
    }
    else {
      getSP_ChangedList();
    }
  }, [updateData]);

  useEffect(() => {
    if (mt.data)
      setShowMT(true);
  }, [mt]);

  function handleConfirmModal() {
    setShowModal(!showModal);
  }

  function toggleCSVAdd() {
    setCsvAdd(!csvAdd);
  }

  function renderCSVModal() {
    return (
      <Upload
        showUpload={csvAdd}
        setCsvAdd={setCsvAdd}
        toggleCSVAdd={toggleCSVAdd}
        user={props.user}
      ></Upload>
    );
  }

  useEffect(() => {
    if (newPAFormOpen) {
      axios.get(APIURL + "/customers/v2/associated", {
        params: {
          company_id: props.user.comp_id,
          employee_id: props.user.emp_id,
          type: props.user.permissions.AdminLevelCustomers ? "Admin" : "Manager"
        },
      })
        .then((response) => {
          setCustomerList(response.data.filter((cus) => cus.cus_status === 'Active'));
        })
        .catch((error) => {
          console.log(error);
          setCustomerList([]);
        });
    }
  }, [newPAFormOpen]);

  const addPreAuthForm = () => {
    return (
      <div>
        <Dialog open={newPAFormOpen} onClose={handleSnackbarAlertClose}>
          <DialogTitle sx={{ width: '100%', textAlign: 'center', borderBottom: '1px solid lightgray' }}>
            Add New Prior Authorization
          </DialogTitle>
          <DialogContent>
            <Autocomplete
              options={customerList}
              value={customerList.find(cus => cus.DDDID === PAFormData.DDDID) || null}
              getOptionLabel={(option) => option?.cus_name || ''}
              isOptionEqualToValue={(option, value) => option.DDDID === value.DDDID}
              onChange={(event, value) => { setPAFormData({ ...PAFormData, DDDID: value ? value.DDDID : '' }); }}
              renderOption={(props, option) => (
                <li {...props} key={option.cus_id}>
                  {option.cus_name}
                </li>
              )}
              renderInput={(params) => <TextField {...params} label="Select Customer" error={!PAFormData.DDDID} />}
              sx={{ marginTop: 2 }}
            />
            <TextField
              label="Member Medicaid"
              value={PAFormData.memberMedicaid}
              sx={{ marginTop: 2 }}
              onChange={(event) => setPAFormData({ ...PAFormData, memberMedicaid: event.target.value })}
              fullWidth
              error={!PAFormData.memberMedicaid}
            />
            <TextField
              label="Provider Medicaid"
              value={PAFormData.providerMedicaid}
              sx={{ marginTop: 2 }}
              onChange={(event) => setPAFormData({ ...PAFormData, providerMedicaid: event.target.value })}
              fullWidth
              error={!PAFormData.providerMedicaid}
            />
            <TextField
              label="Prior Authorization"
              value={PAFormData.priorAuth}
              sx={{ marginTop: 2 }}
              onChange={(event) => setPAFormData({ ...PAFormData, priorAuth: event.target.value })}
              fullWidth
              error={!PAFormData.priorAuth}
            />
            <TextField
              label="Procedure Code"
              value={PAFormData.procedureCode}
              sx={{ marginTop: 2 }}
              onChange={(event) => setPAFormData({ ...PAFormData, procedureCode: event.target.value })}
              fullWidth
              error={!PAFormData.procedureCode}
            />
            <Grid sx={{ marginTop: 2 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Start Date"
                  value={PAFormData.startDate}
                  onChange={(newValue) => setPAFormData({ ...PAFormData, startDate: newValue })}
                  sx={{ width: '49%', marginRight: 1 }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="End Date"
                  value={PAFormData.endDate}
                  onChange={(newValue) => setPAFormData({ ...PAFormData, endDate: newValue })}
                  sx={{ width: '49%' }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2, marginBottom: 2 }}>
              <TextField
                label="Authorized Units"
                type='number'
                value={PAFormData.authUnits}
                sx={{ width: '49%', marginRight: 1 }}
                onChange={(event) => setPAFormData({ ...PAFormData, authUnits: event.target.value })}
                fullWidth
                error={!PAFormData.authUnits}
              />
              <TextField
                label="Authorized Amount"
                type='number'
                value={PAFormData.authAmount}
                sx={{ width: '49%' }}
                onChange={(event) => setPAFormData({ ...PAFormData, authAmount: event.target.value })}
                fullWidth
                error={!PAFormData.authAmount}
              />
            </Grid>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={{ marginTop: 2 }}
              onClick={handleAddPreAuth}
              disabled={
                addingPreAuth ||
                !PAFormData.DDDID ||
                !PAFormData.memberMedicaid ||
                !PAFormData.providerMedicaid ||
                !PAFormData.priorAuth ||
                !PAFormData.procedureCode ||
                !PAFormData.startDate ||
                !PAFormData.endDate ||
                !PAFormData.authUnits ||
                !PAFormData.authAmount
              }
            >
              Add Prior Authorization
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  const handleAddPreAuth = async () => {
    setAddingPreAuth(true);

    await axios
      .post(APIURL + `/preauth/addPA`, {
        DDDID: PAFormData.DDDID,
        memberMedicaid: PAFormData.memberMedicaid,
        providerMedicaid: PAFormData.providerMedicaid,
        priorAuth: PAFormData.priorAuth,
        procedureCode: PAFormData.procedureCode.slice(0, 5),
        procedureCodeModifier: PAFormData.procedureCode.slice(5).replaceAll(":", ''),
        startDate: moment(PAFormData.startDate).format('YYYY-MM-DD'),
        endDate: moment(PAFormData.endDate).format('YYYY-MM-DD'),
        authUnits: PAFormData.authUnits,
        authAmount: PAFormData.authAmount,
        companyId: props.comp_id,
        uploadedBy: props.user.emp_id,
      })
      .then(function (response) {
        // Refresh DataSource to show the new PreAuth entry
        // if (dataSource) {
        //   setDataSource(createDataSource());
        // }
        setAlertMessage('Prior Authorization saved successfully!');
        setAlertType('success');
      })
      .catch(function (error) {
        console.log(error);
        setAlertMessage('An error occurred while saving the Prior Authorization!');
        setAlertType('error');
      });
  };

  const SnackbarComponent = () => {
    return (
      <div>
        <Snackbar open={alertMessage ? true : false} autoHideDuration={2000} onClose={handleSnackbarAlertClose}>
          <Alert severity={alertType} elevation={6} variant="filled">
            {alertMessage}
            <IconButton
              sx={{ p: 0.25 }}
              onClick={handleSnackbarAlertClose}
            >
              <CloseIcon />
            </IconButton>
          </Alert>
        </Snackbar>
      </div>
    );
  };

  const handleSnackbarAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertMessage('');
    setAlertType('');

    setNewPAFormOpen(false);
    setAddingPreAuth(false);
    setPAFormData({
      DDDID: '',
      memberMedicaid: '',
      providerMedicaid: '',
      priorAuth: '',
      procedureCode: '',
      startDate: moment(),
      endDate: moment(),
      authUnits: '',
      authAmount: '',
    });
  };

  useEffect(() => {
    async function fetchTaskForms() {
      try {
        const response = await axios.get(APIURL + `/customer_form/task/${selectedTaskID}`)
        setTaskForms(response.data);
      } catch (error) {
        console.log(error);
      }
    }

    if (selectedTaskID) {
      fetchTaskForms();
    }
  }, [selectedTaskID]);

  useEffect(() => {
    if (taskForms[0]?.tas_claim_id) {
      setClaimStatusLoading(true);
      axios.get(APIURL + `/claims?claim_id=${taskForms[0].tas_claim_id}`)
        .then(res => setClaimStatus(res.data.Status))
        .catch(() => setClaimStatus(null))
        .finally(() => setClaimStatusLoading(false));
    } else {
      setClaimStatus(null);
    }
  }, [taskForms]);

  function onDateChange(newValue) {
    setCurrMonth(moment(newValue).startOf("month"));
    setCurrMonthEnd(moment(newValue).endOf("month"));

    setSelectionModel({ type: 'include', ids: new Set() });
    setSelectValidClaims(false);
  }

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  function getSelectButton() {
    const checkClaimStatus = (tasks) => {
      return tasks ? (tasks[0] ? (tasks[0].tas_preAuth_id ? 'Sent to Claims' : '') : '') : '';
    };

    return (
      <div className="flex-item-d">
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
          <Button
            variant="contained"
            fullWidth={true}
            onClick={() => { setSelectValidClaims(true); }}
            disabled={isLoading || claimsList.filter(
              (claim) =>
                (primaryBusinessType === 101 ? ((claim.tas_mm_status === 'Approved' || claim.ChargeIdentified === 'Customer added') && claim.priorAuth && !claim.tas_preAuth_id) : (claim.taskIds && claim.priorAuth && checkClaimStatus(claim.tasks) !== 'Sent to Claims')) &&
                moment(claim.startDate).utc().month() === currentMonth.month() &&
                moment(claim.startDate).utc().year() === currentMonth.year() &&
                claim.cus_name
            ).length === 0}
          >
            Select Fileable Claims
          </Button>
        </Box>
      </div>
    );
  }

  function getUnselectButton() {
    return (
      <div className="flex-item-d1">
        <Box display="flex">
          <Button
            variant="contained"
            sx={{ width: "80%" }}
            onClick={() => {
              setSelectValidClaims(false);
              setSelectionModel({ type: 'include', ids: new Set() });
            }}
            style={{
              backgroundColor: "white",
              color: "grey"
            }}
          >
            Unselect All
          </Button>
        </Box>
      </div>
    );
  }

  function getSendButton() {
    return (
      <div className="flex-item-d2">
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
          <Button
            variant="contained"
            onClick={() => { handleConfirmModal(); }}
            color="success"
          >
            Send
          </Button>
        </Box>
      </div>
    );
  }

  const handleSaveSettings = async () => {
    let settings = apiRef.current.exportState();
    settings.columnVisibilityModel = colVisModel;
    settings.density = density;
    settings = JSON.stringify(settings);

    let saveGridSettings = await axios.put(`${APIURL}/datagrid`, { user_id: props.user.emp_id, report_id: gridId, settings: settings });

    console.log(saveGridSettings);
  }

  const handleColumnOrderChange = (params) => {
    let newOrder = [];
    setOrderedColumns((prevOrderedColumns) => {
      if (prevOrderedColumns.length === 0) {
        return apiRef.current.exportState().columns.orderedFields;
      }
      const newOrderedColumns = [...prevOrderedColumns];
      const oldIndex = params.oldIndex;
      const targetIndex = params.targetIndex;
      const oldColumn = prevOrderedColumns[oldIndex];
      newOrderedColumns.splice(oldIndex, 1);
      newOrderedColumns.splice(targetIndex, 0, oldColumn);
      newOrder = newOrderedColumns;
      return newOrderedColumns;
    });
    setInitialSettings((prevSettings) => {
      return {
        ...prevSettings,
        columns: {
          ...prevSettings.columns,
          orderedFields: newOrder.length !== 0 ? newOrder : apiRef.current.exportState().columns.orderedFields,
        }
      }
    })
  };

  const handleCellDoubleClick = (params) => {
    if (params.field === "billingNote") {
      setEditNote(true);
      setEditRow(params.row);
      setNoteText(params.row.billingNote);
    }
  };

  async function updateBillingNote(b_id, note) {
    try {
      if (note && note.replace(/\s/g, '').length !== 0) {
        await axios.put(APIURL + "/accountsReceivable/billingNote", {
          billing_note_id: b_id,
          billing_note: note,
          empID: props.user.emp_id,
        });

        setAlertMessage('Note successfully saved.');
        setAlertType('success');
      } else {
        setAlertMessage('Note cannot be empty');
        setAlertType('error');
      }
    } catch (error) {
      setAlertMessage(error.message);
      setAlertType('error');
    }

    setEditNote(false);
    setEditRow(null);
  }

  async function addBillingNote(pa_id, note) {
    try {
      if (note && note.replace(/\s/g, '').length !== 0) {
        await axios.post(APIURL + "/accountsReceivable/billingNote", {
          preAuth_id: pa_id,
          billing_note: note,
          empID: props.user.emp_id,
        });

        setAlertMessage('Note successfully saved.');
        setAlertType('success');
      } else {
        setAlertMessage('Note cannot be empty');
        setAlertType('error');
      }
    } catch (error) {
      setAlertMessage(error.message);
      setAlertType('error');
    }
    setEditNote(false);
    setEditRow(null);
  }

  function getSC_ChangedList() {
    // Columns for Support Co-ordination
    let SC_columns = [
      {
        field: "id",
        headerName: "ID",
        width: 50,
        hide: true,
      },
      {
        field: "primaryID",
        headerName: "Primary ID",
        width: 50,
        hide: true,
      },
      {
        field: 'ChargeIdentified',
        headerName: 'Charge Identified',
        width: 125,
      },
      {
        field: "DDDID",
        headerName: "DDDID",
        width: 80,
        hide: false,
        editable: false,
      },
      {
        field: "PatientName",
        headerName: "Patient Name",
        width: 150,
        hide: false,
        editable: false,
      },
      {
        field: "DateOfBirth",
        headerName: "DOB",
        width: 100,
        hide: false,
        editable: false,
      },
      {
        field: "Gender",
        headerName: "Gender",
        width: 65,
        hide: false,
        editable: false,
      },
      {
        field: "DDD_tier",
        headerName: "DDD Tier",
        width: 65,
        hide: false,
        editable: false,
      },
      {
        field: "memberMedicaid",
        headerName: "Medicaid ID",
        width: 120,
        hide: false,
        editable: false,
      },
      {
        field: "priorAuth",
        headerName: "Prior Auth",
        width: 110,
        hide: false,
        editable: false,
      },
      {
        field: "procedureCode",
        headerName: "Proc Code",
        width: 100,
        hide: false,
      },
      {
        field: "procedureCodeModifier",
        width: 100,
        hide: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Proc Code Modifier
            </div>
          );
        },
      },
      {
        field: "DiagnosisCode",
        width: 90,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Diagnosis Code
            </div>
          );
        },
      },
      {
        field: "startDate",
        width: 100,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task Start Date
            </div>
          );
        },
      },
      {
        field: "endDate",
        width: 100,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task End Date
            </div>
          );
        },
      },
      {
        field: "authUnits",
        width: 50,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Units
            </div>
          );
        },
      },
      {
        field: "authAmount",
        width: 70,
        hide: false,
        editable: false,
        align: "right",
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Amount
            </div>
          );
        },
      },
      {
        field: "task_id",
        headerName: "Task ID",
        width: 120,
        hide: true,
      },
      {
        field: "tas_title",
        headerName: "Task Title",
        width: 120,
        hide: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div class="crop">{params.value}</div>
            </Tooltip>
          )
        },
      },
      {
        field: "tas_type",
        headerName: "Task Type",
        width: 120,
        hide: false,
      },
      {
        field: "tas_start_date",
        headerName: "Task Date",
        width: 120,
        hide: false,
      },
      {
        field: "taskStatus",
        headerName: "Status",
        width: 120,
        hide: false,
      },
      {
        field: "Status",
        headerName: "Claim Status",
        width: 120,
        hide: false,
      },
      {
        field: "tas_id",
        headerName: "MMT",
        width: 70,
        hide: false,
        renderCell: (params) => {
          const onClick = async () => {
            const mm = await axios.get(APIURL + "/monthlymonitoring/" + params.value);
            if (mm.data !== '') {
              const mmt = (mm.data[0]);
              setMT(mmt);
            }
          }
          return (
            <div>
              {!!params.value &&
                <div style={{ color: '#3FA7D6', padding: '10px' }}>
                  <Link href="#" underline="hover" onClick={onClick}>
                    <i class="far fa-sticky-note" style={{ marginRight: '5px' }}></i>
                    View
                  </Link>
                </div>
              }
              {Object.keys(params.row).length !== 0 && !params.value &&
                <div style={{ color: '#3FA7D6', padding: '10px' }}>
                  <Link style={{ textDecoration: 'none', color: 'grey', cursor: 'auto' }} href="#">
                    <i class="far fa-sticky-note" style={{ marginRight: '5px' }}></i>
                    View
                  </Link>
                </div>}
            </div>
          )
        }
      },
      {
        field: "mt_status",
        headerName: "MT Status",
        width: 150,
        hide: false,
      },
      {
        field: "errCode",
        headerName: "Error Code",
        width: 120,
        hide: false,
      },
      {
        field: "errDescription",
        headerName: "Error Description",
        width: 140,
        hide: false,
      },
      {
        field: "billingNote",
        headerName: "Notes",
        width: 300,
        editable: true,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div class="crop">{params.value}</div>
            </Tooltip>
          );
        },
      },
    ]

    if (initialSettings.columns) {
      SC_columns = SC_columns.sort((a, b) => {
        const indexA = initialSettings.columns.orderedFields.indexOf(a.field);
        const indexB = initialSettings.columns.orderedFields.indexOf(b.field);

        if (indexA === -1 && indexB === -1) return 0;

        if (indexA === -1) return 1;

        if (indexB === -1) return -1;

        return indexA - indexB;
      });
    }

    if (initialSettings?.columns?.dimensions) {
      Object.keys(initialSettings.columns.dimensions).forEach((field) => {
        try {
          const colIndex = SC_columns.findIndex(col => col.field === field);
          if (colIndex !== -1) {
            SC_columns[colIndex].width = initialSettings.columns.dimensions[field].width;
          }
        } catch (e) {
          console.log('ERROR', e);
        }
      });
    }

    const toolbarButtons = [
      () => (
        <Tooltip title="Add an entry">
          <ToolbarButton onClick={() => setNewPAFormOpen(true)} disabled={false}>
            <AddIcon />
          </ToolbarButton>
        </Tooltip>
      )
    ];

    let claimsListFin = (
      <div style={{ height: 'calc(100vh - 225px)', width: '100%' }}>
        <DataGridPro
          apiRef={apiRef}
          onColumnOrderChange={handleColumnOrderChange}
          density={density}
          onDensityChange={(newDensity) => setDensity(newDensity)}
          columnVisibilityModel={colVisModel}
          onColumnVisibilityModelChange={(newModel) => setColVisModel(newModel)}
          initialState={initialSettings.columns ? initialSettings : { sorting: { sortModel: [{ field: "mt_status", sort: "desc" }, { field: "priorAuth", sort: "desc" }] } }}
          onRowSelected={(params) => console.log(params)}
          checkboxSelection={true}
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setSelectionModel(newRowSelectionModel);
          }}
          rows={formattedRows}
          columns={SC_columns}
          slots={{
            toolbar: DefaultToolbar,
            noRowsOverlay: () => (
              <Box sx={{ height: "100%", display: 'flex', alignItems: "center", margin: 'auto', justifyContent: "center" }}>
                <Typography>No Prior Authorizations for this month in the system</Typography>
              </Box>
            ),
          }}
          slotProps={{
            toolbar: {
              children: (
                <>
                  {(Array.isArray(toolbarButtons) ? toolbarButtons : []).map((Btn, idx) => (
                    <Btn key={idx} />
                  ))}
                  <SaveViewButton onClick={debounce(handleSaveSettings, 500)} />
                </>
              ),
            },
          }}
          isRowSelectable={(params) => (params.row.PatientName && (params.row.mt_status === "Approved" || params.row.ChargeIdentified === 'Customer added') && params.row.priorAuth && params.row.Status !== 'Sent to Claims')}
          disableRowSelectionOnClick
          loading={isLoading}
          showToolbar
          treeData
          getTreeDataPath={(row) => row.hierarchy}
        />
      </div>
    );
    return claimsListFin;
  }

  function getSP_ChangedList() {
    // Columns for Service Providers
    let SP_columns = [
      {
        field: "id",
        headerName: "ID",
        width: 50,
        hide: true,
      },
      {
        field: "primaryID",
        headerName: "Primary ID",
        width: 50,
        hide: true,
      },
      {
        field: 'ChargeIdentified',
        headerName: 'Charge Identified',
        width: 125,
      },
      {
        field: "DDDID",
        headerName: "DDDID",
        width: 80,
        hide: false,
        editable: false,
      },
      {
        field: "PatientName",
        headerName: "Patient Name",
        width: 150,
        hide: false,
        editable: false,
      },
      {
        field: "DateOfBirth",
        headerName: "DOB",
        width: 100,
        hide: false,
        editable: false,
      },
      {
        field: "Gender",
        headerName: "Gender",
        width: 65,
        hide: false,
        editable: false,
      },
      {
        field: "DDD_tier",
        headerName: "DDD Tier",
        width: 65,
        hide: false,
        editable: false,
      },
      {
        field: "memberMedicaid",
        headerName: "Medicaid ID",
        width: 120,
        hide: false,
        editable: false,
      },
      {
        field: "priorAuth",
        headerName: "Prior Auth",
        width: 110,
        hide: false,
        editable: false,
      },
      {
        field: "procedureCode",
        headerName: "Proc Code",
        width: 100,
        hide: false,
      },
      {
        field: "procedureCodeModifier",
        width: 100,
        hide: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Proc Code Modifier
            </div>
          );
        },
      },
      {
        field: "DiagnosisCode",
        width: 90,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Diagnosis Code
            </div>
          );
        },
      },
      {
        field: "startDate",
        width: 100,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task Start Date
            </div>
          );
        },
      },
      {
        field: "endDate",
        width: 100,
        hide: false,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Task End Date
            </div>
          );
        },
      },
      {
        field: "authUnits",
        width: 50,
        hide: props.user.type === 'Admin' ? false : true,
        editable: false,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Units
            </div>
          );
        },
      },
      {
        field: "authAmount",
        width: 70,
        hide: props.user.type === 'Admin' ? false : true,
        editable: false,
        align: "right",
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Auth Amount
            </div>
          );
        },
      },
      {
        field: "taskStatus",
        headerName: "Status",
        width: 120,
        hide: false,
      },
      {
        field: "tas_ids",
        headerName: "Forms/Task IDs",
        width: 120,
        hide: false,
        renderCell: (params) => {
          let ids = params.value?.split(',').map(id => id.trim()).filter(Boolean) || [];

          return (
            <div>
              {ids.map((id, idx) => (
                <Link
                  key={id}
                  href={`#`}
                  underline="hover"
                  onClick={(e) => {
                    setSelectedTaskID(id);
                  }}
                  sx={{ marginRight: 1 }}
                >
                  {id}
                </Link>
              ))}
            </div>
          );
        },
      },
      {
        field: "tas_type",
        headerName: "Task Type",
        width: 120,
        hide: false,
      },
      {
        field: "cumulativeUnits",
        width: 55,
        hide: props.user.type === 'Admin' ? false : true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Units used
            </div>
          );
        },
      },
      {
        field: "remainingUnits",
        width: 80,
        hide: props.user.type === 'Admin' ? false : true,
        renderHeader: (params) => {
          return (
            <div
              style={{
                maxHeight: "inherit",
                width: "100%",
                whiteSpace: "initial",
                lineHeight: "16px",
                verticalAlign: "bottom",
              }}
            >
              Units remaining
            </div>
          );
        },
      },
      {
        field: "Status",
        headerName: "Claim Status",
        width: 120,
        hide: false,
      },
      {
        field: "errCode",
        headerName: "Error Code",
        width: 120,
        hide: false,
      },
      {
        field: "errDescription",
        headerName: "Error Description",
        width: 140,
        hide: false,
      },
      {
        field: "billingNote",
        headerName: "Notes",
        width: 300,
        editable: true,
        renderCell: (params) => {
          return (
            <Tooltip title={params.value}>
              <div class="crop">{params.value}</div>
            </Tooltip>
          );
        },
      },
      {
        field: "isNewPlan",
        headerName: "Is New Plan",
        width: 100,
        hide: false,
      },
      {
        field: "serviceType",
        headerName: "Service Type",
        width: 100,
        hide: false,
      },
    ]

    if (initialSettings.columns) {
      SP_columns = SP_columns.sort((a, b) => {
        const indexA = initialSettings.columns.orderedFields.indexOf(a.field);
        const indexB = initialSettings.columns.orderedFields.indexOf(b.field);

        if (indexA === -1 && indexB === -1) return 0;

        if (indexA === -1) return 1;

        if (indexB === -1) return -1;

        return indexA - indexB;
      });
    }

    if (initialSettings?.columns?.dimensions) {
      Object.keys(initialSettings.columns.dimensions).forEach((field) => {
        try {
          const colIndex = SP_columns.findIndex(col => col.field === field);
          if (colIndex !== -1) {
            SP_columns[colIndex].width = initialSettings.columns.dimensions[field].width;
          }
        } catch (e) {
          console.log('ERROR', e);
        }
      });
    }

    const toolbarButtons = [
      () => (
        <Tooltip title="Add an entry">
          <ToolbarButton onClick={() => setNewPAFormOpen(true)} disabled={false}>
            <AddIcon />
          </ToolbarButton>
        </Tooltip>
      )
    ];

    let claimsListFin = (
      <div style={{ height: 'calc(100vh - 225px)', width: '100%' }}>
        <DataGridPro
          apiRef={apiRef}
          onColumnOrderChange={handleColumnOrderChange}
          density={density}
          onDensityChange={(newDensity) => setDensity(newDensity)}
          columnVisibilityModel={colVisModel}
          onColumnVisibilityModelChange={(newModel) => setColVisModel(newModel)}
          initialState={initialSettings.columns ? initialSettings : { sorting: { sortModel: [{ field: "taskStatus", sort: "desc" }, { field: "startDate", sort: "desc" }] } }}
          onRowSelected={(params) => console.log(params)}
          checkboxSelection={true}
          rowSelectionModel={selectionModel}
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setSelectionModel(newRowSelectionModel);
          }}
          rows={formattedRows}
          columns={SP_columns}
          slots={{
            toolbar: DefaultToolbar,
            noRowsOverlay: () => (
              <Box sx={{ height: "100%", display: 'flex', alignItems: "center", margin: 'auto', justifyContent: "center" }}>
                <Typography>No Prior Authorizations for this month in the system</Typography>
              </Box>
            ),
          }}
          slotProps={{
            toolbar: {
              children: (
                <>
                  {(Array.isArray(toolbarButtons) ? toolbarButtons : []).map((Btn, idx) => (
                    <Btn key={idx} />
                  ))}
                  <SaveViewButton onClick={debounce(handleSaveSettings, 500)} />
                </>
              ),
            },
          }}
          isRowSelectable={(params) => params.row.PatientName && params.row.tas_ids && params.row.priorAuth && params.row.Status !== 'Sent to Claims'}
          onCellDoubleClick={(params, event) => { handleCellDoubleClick(params); }}
          disableRowSelectionOnClick
          loading={isLoading}
          showToolbar
          treeData
          getTreeDataPath={(row) => row.hierarchy}
        />
      </div>
    );
    return claimsListFin;
  }

  return (
    <div style={{ display: "flex", backgroundColor: "#fafafa" }}>
      <div
        style={{ display: "flex", marginTop: 30, width: "calc(100vw - 500px)" }}
        className="col-lg-12 col-sm-7 d-flex flex-column justify-content-start"
      >
        <div className="flex-container" style={{ display: "flex" }}>
          <div
            className="flex-item"
            style={{ height: "40px", marginBottom: "10px", }}
          >
            <Button
              size="large"
              variant="contained"
              onClick={() => onDateChange(currentMonth.subtract(1, "month"))}
            >
              <i className="fas fa-arrow-left"></i>
            </Button>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Select Month"
                views={["year", "month"]}
                value={new Date(currentMonth)}
                sx={{ marginLeft: "10px", marginRight: "10px" }}
                slotProps={{ textField: { size: 'small' } }}
                onChange={(newValue) => {
                  onDateChange(newValue);
                }}
              />
            </LocalizationProvider>
            <Button
              size="large"
              variant="contained"
              onClick={() => onDateChange(currentMonth.add(1, "month"))}
            >
              <i className="fas fa-arrow-right"></i>
            </Button>
          </div>
          <div className="right">
            <div className="flex-item-u">
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Button
                  variant="contained"
                  style={{ marginLeft: "-50px" }}
                  onClick={() => { setCsvAdd(!csvAdd); }}
                  disabled={isLoading}
                >
                  UPLOAD PRE-AUTH CSV
                </Button>
              </Box>
            </div>
            {!selectValidClaims && selectionModel.ids.size === 0 && getSelectButton()}
            {(selectValidClaims || selectionModel.ids.size !== 0) && getUnselectButton()}
            {(selectValidClaims || selectionModel.ids.size !== 0) && getSendButton()}
          </div>
        </div>

        {primaryBusinessType === 101 && getSC_ChangedList()}
        {[102, 105].includes(primaryBusinessType) && getSP_ChangedList()}

        {renderCSVModal()}
        {addPreAuthForm()}
        {SnackbarComponent()}
      </div>
      <Dialog open={showModal} onClose={handleConfirmModal}>
        <DialogTitle sx={{ textAlign: 'center' }}>SUBMIT CLAIMS</DialogTitle>
        <DialogContent sx={{ textAlign: 'center' }}>
          <Typography>
            You have selected {selectionModel.ids.size} claims.
          </Typography>
          <Typography>
            Are you sure you want to send the selected claims?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', padding: 3 }}>
          <Button
            variant="outlined"
            onClick={handleConfirmModal}
          >
            Back
          </Button>
          <Box style={{ width: "30px" }}></Box>
          <Button
            variant="contained"
            onClick={() => {
              setNextStep(true);
              handleConfirmModal();
            }}
            color="success"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showMT} onClose={handleCloseMT} maxWidth="xl" fullWidth>
        <DialogTitle>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>{mt.mt_type === "Monthly" ? "Monthly" : "Quarterly/Annual"} Monitoring Tool</Typography>
        </DialogTitle>
        <DialogContent>
          {mt?.mt_type === "Monthly" ?
            <div>
              <MonthlyTool // fully expanded for printing and downloading
                data={mt?.data ? JSON.parse(mt.data) : {}}
                expand={true}
                read={true}
                onChange={() => { return }}
              />
              {mt?.mt_type === "Monthly" &&
                <Box sx={{ overflow: 'hidden', height: 0 }}>
                  <MonthlyTool // fully expanded for printing and downloading
                    data={mt?.data ? JSON.parse(mt.data) : {}}
                    onChange={() => { return }}
                    ref={ref}
                    expand={true}
                  />
                </Box>
              }
            </div> :
            <div >
              <QuarterlyAnnualTool // fully expanded for printing and downloading
                data={mt?.data ? JSON.parse(mt.data) : {}}
                expand={true}
                read={true}
                onChange={() => { return }}
              />
              {mt?.mt_type === "Quarterly" &&
                <Box sx={{ overflow: 'hidden', height: 0 }}>
                  <QuarterlyAnnualTool // fully expanded for printing and downloading
                    data={mt?.data ? JSON.parse(mt.data) : {}}
                    onChange={() => { return }}
                    ref={ref}
                    expand={true}
                  />
                </Box>
              }
            </div>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMT}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={selectedTaskID ? true : false}
        onClose={() => setSelectedTaskID(null)}
        maxWidth="md"
        fullWidth
        scroll='body'
        disableRestoreFocus
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
          borderBottom: '1px solid #e0e0e0'
        }}>
          Forms

          {taskForms.length ?
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                {taskForms[0]?.tas_title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {convertTime(taskForms[0]?.empLocdate, taskForms[0]?.empLocate_timezone, moment.tz.guess()) ?? moment(taskForms[0]?.empLocdate).utc().format('MM/DD/YYYY hh:mm A')} - {convertTime(taskForms[0]?.checkoutEmpDate, taskForms[0]?.empLocate_timezone, moment.tz.guess()) ?? moment(taskForms[0]?.checkoutEmpDate).utc().format('MM/DD/YYYY hh:mm A')}
              </Typography>
              {taskForms[0]?.tas_claim_id && (
                claimStatusLoading
                  ? <CircularProgress size={18} />
                  : claimStatus && (
                    <Chip
                      label={`Billing Status: ${claimStatus}`}
                      size="small"
                      color="success"
                      sx={{ mt: 0.5 }}
                    />
                  )
              )}
            </Box> : ''
          }
        </DialogTitle>
        <DialogContent>
          {taskForms.length === 0 ? (
            <Typography>No forms available for this task.</Typography>
          ) : (
            <Box>
              {taskForms.map((form, idx) => (
                <Button
                  key={form.form_name || idx}
                  variant="outlined"
                  sx={{ m: 1, width: '100%', justifyContent: 'flex-start' }}
                  onClick={() => {
                    setSelectedForm(form);
                    setOpenFormDialog(true);
                  }}
                >
                  {form.form_name || `Form ${idx + 1}`}
                </Button>
              ))}
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={openFormDialog}
        onClose={() => setOpenFormDialog(false)}
        maxWidth="md"
        fullWidth
        scroll='body'
        disableRestoreFocus
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
          borderBottom: '1px solid #e0e0e0'
        }}>
          {selectedForm?.form_name || "Form"}
        </DialogTitle>
        <DialogContent>
          {selectedForm && (
            <Form
              form={JSON.parse(selectedForm?.translated_json_schema ? selectedForm?.translated_json_schema : selectedForm?.json_schema)}
              submission={JSON.parse(selectedForm?.data)}
              options={{
                readOnly: true,
                hide: {
                  submit: true,
                }
              }}
            />
          )}
        </DialogContent>
        {selectedForm && (
          <DialogActions sx={{ justifyContent: 'flex-start', padding: '8px 24px 16px' }}>
            <FormAttachments task_id={selectedForm.task_id} readOnly />
          </DialogActions>
        )}
      </Dialog>
      {editNote &&
        <Dialog open={editNote} onClose={() => { setEditNote(false); setEditRow(null); }} maxWidth="lg" fullWidth>
          <DialogTitle>{editRow.billingNoteId ? 'Edit Note' : 'Add Note'}</DialogTitle>
          <DialogContent>
            <div>
              <TextField
                multiline
                value={noteText}
                onChange={(event) => {
                  setNoteText(event.target.value);
                }}
                style={{ margin: '5px', width: '100%' }}
                inputProps={{ maxLength: 2000 }}
                minRows={8}
                label="Note"
                variant="outlined"
                id="bNote"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              sx={{
                width: '100%',
                padding: '5px',
                margin: '5px',
              }}
              onClick={() => editRow.billingNoteId ? updateBillingNote(editRow.billingNoteId, noteText) : addBillingNote(editRow.primaryID, noteText)}
            >
              {editRow.billingNoteId ? 'Edit Note' : 'Add Note'}
            </Button>
          </DialogActions>
        </Dialog>
      }
    </div>
  );
}